import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import DoneIcon from './DoneIcon';
import { BsQuestionCircleFill } from "react-icons/bs";
export var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["Salmon"] = "salmon";
    ButtonVariant["Outlined"] = "outlined";
    ButtonVariant["SalmonOutlined"] = "salmonOutlined";
    ButtonVariant["Purple"] = "purple";
    ButtonVariant["Tertiary"] = "tertiary";
    ButtonVariant["Quiet"] = "quiet";
})(ButtonVariant || (ButtonVariant = {}));
const Button = ({ children, variant, onClick, className, loading, disabled, disabledError, done, toolTip, toolTipId, style }) => {
    let classes = "py-3 min-w-full px-3 block active:relative active:-left-2 active:-bottom-2 no-underline static";
    const [showDisabledError, setShowDisabledError] = useState(false);
    let inlineStyle = { width: "min-content" };
    if (style) {
        style = Object.assign(Object.assign({}, inlineStyle), style);
    }
    if (variant === 'salmon') {
        classes += " border-none text-white shadow-lg active:shadow-none text-white focus:outline-none";
        if (done || disabled) {
            classes += " bg-wfGray-600";
        }
        else {
            classes += " bg-salmon-600 active:bg-salmon-700";
        }
    }
    if (variant === 'purple') {
        classes += " py-4 border-none text-black shadow-lg active:shadow-none focus:outline-none";
        if (done || disabled) {
            classes += " bg-wfGray-600";
        }
        else {
            classes += " bg-wfPurple-500 hover:bg-wfPurple-600 active:bg-wfPurple-700";
        }
    }
    if (variant === 'outlined') {
        classes += " bg-white rounded-none border shadow-lg active:shadow-none focus:outline-none";
        if (disabled) {
            classes += " border-wfGray-300 hover:border-wfGray-300 text-wfGray-300";
        }
        else {
            classes += " border-wfGray-600 hover:border-wfGray-800 text-wfGray-800";
        }
    }
    if (variant === 'salmonOutlined') {
        classes += " border-salmon-600 hover:border-salmon-700 bg-white rounded-none border text-wfGray-800 focus:outline-none";
    }
    if (variant === 'tertiary') {
        classes += " border-wfGray-300 hover:border-wfGray-800 bg-white rounded-none border text-wfGray-800 focus:outline-none";
    }
    if (variant === 'quiet') {
        classes = "py-3 block text-salmon-600 hover:underline active:underline no-underline static";
    }
    if (disabled) {
        classes += " cursor-not-allowed";
    }
    const clickHandler = () => {
        if (typeof onClick === "function")
            onClick();
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "w-full flex justify-center relative", children: [_jsx("button", { onClick: disabled ? () => { setShowDisabledError(true); } : clickHandler, disabled: (disabled && !disabledError) || done, className: classes + " " + className, style: style, children: _jsxs(_Fragment, { children: [children, done && _jsx(DoneIcon, {})] }) }), toolTip && _jsx(BsQuestionCircleFill, { "data-tooltip-html": toolTip, "data-tooltip-id": toolTipId })] }), (disabledError && showDisabledError) && (_jsx("span", { className: "text-sm text-wfRed-600 mb-2", children: disabledError }))] }));
};
export default Button;
